/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfOrderDto } from '../../models/paginated-dto-of-order-dto';

export interface GetCustomerOrders$Params {
}

export function getCustomerOrders(http: HttpClient, rootUrl: string, params?: GetCustomerOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfOrderDto>> {
  const rb = new RequestBuilder(rootUrl, getCustomerOrders.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfOrderDto>;
    })
  );
}

getCustomerOrders.PATH = '/api/v1/order/history';
